import { render, staticRenderFns } from "./quotation-list.vue?vue&type=template&id=a359d4fc&scoped=true&"
import script from "./quotation-list.vue?vue&type=script&lang=js&"
export * from "./quotation-list.vue?vue&type=script&lang=js&"
import style0 from "./quotation-list.vue?vue&type=style&index=0&id=a359d4fc&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a359d4fc",
  null
  
)

export default component.exports